const INITIAL_STATE = {
  data: {},
  errors: {},
}
    
const messageReply = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'MESSAGE_REPLAY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'MESSAGE_REPLAY_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default messageReply;